export const TRACKING_LIST_AG_LOCALE: Record<string, string> = {
  noRowsToShow: "データがありません。",
  filterOoo: "検索",
  searchOoo: "検索",
  contains: "含む",
  notContains: "含まない",
  startsWith: "前方一致",
  endsWith: "後方一致",
  equals: "一致",
  notEqual: "一致しない",
  blanks: "（空白）",
  selectAll: "すべて選択",
  applyFilter: "保存",
  cancelFilter: "キャンセル",
  clearFilter: "クリア",
  resetFilter: "リセット",
  andCondition: "AND",
  orCondition: "OR",
  sortAscending: "昇順 (A->Z)",
  sortDescending: "降順 (Z->A)",
  sortUnSort: "なし",
};
